module.exports = __webpack_public_path__ + "static/media/eyes-pwd-close.eb220c04.svg";